import PlanBenefitsStep from "components/steps/PlanBenefitsStep";

const FavPlanPlanBenefitsStep = () => <PlanBenefitsStep />;

export default FavPlanPlanBenefitsStep;
